(function() {
  'use strict';
  angular.module('userProfile')
  .controller('userProfileController', ['$scope','$log','$state', 'UserProfile', '$rootScope', 'secSecurityService', 'TaxLocationUtility',
  function($scope, $log,$state, UserProfile, $rootScope, secSecurityService, TaxLocationUtility){
    var vm = this;
    vm.reset = reset;
    vm.submit = submit;
    vm.unverified =false;
    vm.resend = resend;
    vm.model = {};
    vm.oldUser = {};
    vm.changedValues = {};
    vm.message = "";
    vm.inUserView = true;
    vm.providerContactView = false;

    secSecurityService.hasAnyAuthority('PREVIOUS_ADMINISTRATOR').then((val) => {
      vm.inUserView = val;
    });

    UserProfile.get(function(data) {
      vm.oldUser = data;
      vm.model = angular.copy(data);

      if(vm.oldUser.userType && vm.oldUser.userType == 'provider' && vm.oldUser.dsoProfile) {
    	  vm.providerContactView = true;
      }

      if(data.unverifiedEmail) {
        vm.model.email = data.unverifiedEmail;
        vm.unverified =  true;
        vm.message = "An email has been sent to " + data.unverifiedEmail + `. Please click on the verification link within the email. If you have not
received the verification link within five minutes, please check your spam folder. Password recovery will not be
possible until the email address is verified.`;
      } else {
        vm.model.email = data.verifiedEmail;
        vm.unverified = false;
      }
      TaxLocationUtility.filterLocations(data.locations).then(function(result){ vm.model.taxIdLocations = result; });

    });

    $scope.$watch('errorControl', function() {
      $scope.errorControl && $scope.errorControl.showErrors(['taxId','uniqueList','duplicateDsoTaxId', 'duplicateProviderTaxId']);
    });

    function reset(){
      $scope.maintenanceForm.$setPristine();
      $scope.errorControl.showErrors(['taxId','uniqueList','duplicateDsoTaxId', 'duplicateProviderTaxId']);
      vm.model = angular.copy(vm.oldUser);
      TaxLocationUtility.filterLocations(vm.oldUser.locations).then(function(result){ vm.model.taxIdLocations = result; });
      if(vm.oldUser.unverifiedEmail) {
        vm.model.email = vm.oldUser.unverifiedEmail;
        vm.unverified =  true;
      } else {
        vm.model.email = vm.oldUser.verifiedEmail;
        vm.unverified = false;
      }
    }

    function resend() {
      UserProfile.resend({userId:vm.oldUser.userId}, function() {
        $scope.dnConfirmationMessage.$show("An email verification link has been resent.");
      });
    }

    function submit(){
      $scope.errorControl.showErrors();
      if($scope.maintenanceForm.$valid && $scope.maintenanceForm.$dirty) {
        UserProfile.save(_.pick(vm.model, ['email', 'taxIds', 'firstName', 'lastName']), function(data) {
          $scope.maintenanceForm.$setPristine();
          $rootScope.$broadcast('userProfileChanged', data);
          vm.oldUser = data;
          vm.model = angular.copy(data);
          TaxLocationUtility.filterLocations(data.locations).then(function(result){ vm.model.taxIdLocations = result; });
          if(data.unverifiedEmail) {
            vm.model.email = data.unverifiedEmail;
            vm.unverified =  true;
            vm.message = "An email has been sent to " + data.unverifiedEmail + `. Please click on the verification link within the email. If you have not
    received the verification link within five minutes, please check your spam folder. Password recovery will not be
    possible until the email address is verified.`;
          } else {
            vm.model.email = data.verifiedEmail;
            vm.unverified = false;
          }
          $scope.dnConfirmationMessage.$show("Your profile has been saved successfully.");
        });
      }
    }
  }]);
})();
